import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
// import './Button.css';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: 300,
    width: '100%',
    justifyContent:'space-evenly',

  },
  image: {
    position: 'relative',
    height: 340,
    borderRadius:'21.66px',
    // marginRight:15,
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      height: 100,
    },
    // onClick: () => history.push("/"),
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // color: '#000'
    color: theme.palette.common.black,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
    borderRadius:'21.66px',
    border: '0.4vh solid blue',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity'),
    borderRadius:'21.66px',

   },
  imageTitle: {
    position: 'relative',
    fontWeight:'bold',
    fontSize:'3vh',
    color:'#000',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    backgroundColor: theme.palette.common.black,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
}));


  


export default function ButtonBases() {
  const classes = useStyles();
  // const [isModalVisible, setIsModalVisible] = useState(false);

  // const showModal = () => {
  //   setIsModalVisible(true);
  // };

  // const handleOk = () => {
  //   setIsModalVisible(false);
  // };

  // const handleCancel = () => {
  //   setIsModalVisible(false);
  // };
  const history = useHistory();

  function handlebtn1(){
    history.push('/zones');
  }

  function handlebtn2(){
    history.push('/relaxingzones');

  }

  function handlebtn3(){
    history.push('/violations');
  }

  return (
    <div className={classes.root}>
    
      <ButtonBase
          onClick={handlebtn1}
          focusRipple
          key={1}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width: "32%",
          }}
        >
          <span
            className={classes.imageSrc}
            style={{
              // backgroundImage: `url('https://ic-cdn.flipboard.com/guim.co.uk/c31caee4ace3bae4e8aa18533c9f278211b1966f/_large.jpeg')`,
              backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/pandemic-control.appspot.com/o/Zones2.jpg?alt=media&token=653cab01-9b89-4e94-a707-97fb8c351aea')`,

            }}
          />
          <span className={classes.imageBackdrop} />
          <span className={classes.imageButton}>
            <Typography
              component="span"
              variant="subtitle1"
              color="inherit"
              className={classes.imageTitle}
            >
              <p>ZONES</p>
              <span className={classes.imageMarked} />
            </Typography>
          </span>
        </ButtonBase>

        <ButtonBase
        onClick={handlebtn2}
        focusRipple
        key={2}
        className={classes.image}
        focusVisibleClassName={classes.focusVisible}
        style={{
          width: "32%",
        }}
      >
          <span
          className={classes.imageSrc}
          style={{
            backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/pandemic-control.appspot.com/o/new_clustering.png?alt=media&token=7ae441b7-e151-42b5-ae34-970917e28db8')`,
           
          }}
        />
        <span className={classes.imageBackdrop} />
        <span className={classes.imageButton}>
          <Typography
            component="span"
            variant="subtitle1"
            color="inherit"
            className={classes.imageTitle}
          >
            <p>RELAXING ZONES</p>
            <span className={classes.imageMarked} />
          </Typography>
        </span>
      </ButtonBase>

      <ButtonBase
        onClick={handlebtn3}
        focusRipple
        key={2}
        className={classes.image}
        focusVisibleClassName={classes.focusVisible}
        style={{
          width: "32%",
        }}
      >
         {/* <Modal title="Basic Modal" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
      <p>Some contents...</p>
      <p>Some contents...</p>
      <p>Some contents...</p>
    </Modal> */}
        <span
          className={classes.imageSrc}
          style={{
            backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/pandemic-control.appspot.com/o/Violation.jpg?alt=media&token=eec10cbb-ca4f-4b04-b0fa-c652aeae93ca')`,
           
          }}
        />
        <span className={classes.imageBackdrop} />
        <span className={classes.imageButton}>
          <Typography
            component="span"
            variant="subtitle1"
            color="inherit"
            className={classes.imageTitle}
          >
            <p>VIOLATIONS</p>
            <span className={classes.imageMarked} />
          </Typography>
        </span>
      </ButtonBase>
    </div>
  );
}